import { useEffect, useRef, MutableRefObject } from "react";

type UseObserverProps = {
  callback: () => void;
  isLoading: boolean;
};

export const useObserver = ({
  callback,
  isLoading,
}: UseObserverProps): MutableRefObject<HTMLDivElement | null> => {
  const observer = useRef<IntersectionObserver | null>(null);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (observer.current) {
      observer.current.disconnect();
    }

    if (isLoading) {
      return;
    }

    const clbck: IntersectionObserverCallback = ([entry]) => {
      if (entry.isIntersecting) {
        callback();
      }
    };

    observer.current = new IntersectionObserver(clbck);

    if (ref.current) {
      observer.current.observe(ref.current);
    }

    return () => {
      const hideTsError = observer.current?.disconnect();
    };
  }, [callback, isLoading]);

  return ref;
};
